import React from 'react'
import PropTypes from 'prop-types'

import { profilePicturePlaceholder, circle4, starOverlay } from 'resources/images'

import { ProfilePictureContainer, ProfilePictureImage, CircleScribble, VipIndicator } from './styles'

const ProfilePictureWithScribble = ({ profilePictureUrl = null, size = 50, isVip = false }) => (
  <ProfilePictureContainer size={size}>
    <ProfilePictureImage src={profilePictureUrl ?? profilePicturePlaceholder} />
    <CircleScribble src={circle4} />
    {isVip && <VipIndicator src={starOverlay} />}
  </ProfilePictureContainer>
)

ProfilePictureWithScribble.propTypes = {
  profilePictureUrl: PropTypes.string,
  size: PropTypes.number,
  isVip: PropTypes.bool,
}

export default ProfilePictureWithScribble
